import React, { useRef, useEffect, useCallback } from 'react';
import { Toast } from 'primereact/toast';
import { ModalInstall } from './ModalInstall';
import { Header } from './Header';
import Analitics from './Analitics';
import axios from 'axios';

export const PostLoginWrapper = ({ children, error, isMain, isField, fieldId, isCreateField, stepIndex, prevStep, isNotifications }) => {
    const toast = useRef(null);

    const registrarAcceso = useCallback(async (evento) => {
        try {
            const ipRes = await fetch('https://api.ipify.org?format=json');
            const { ip } = await ipRes.json();

            const fecha = new Date().toLocaleString('sv-SE', {
                timeZone: 'Europe/Madrid',
                hour12: false
            }).slice(0, 19);
            const seccion   = window.location.pathname;

            const email = localStorage.getItem('email') || null;

            let direccion = '';
            try {
                const geoRes = await fetch(`https://ipapi.co/${ip}/json/`);
                const { latitude: lat, longitude: lon } = await geoRes.json();
                const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&accept-language=en`;
                const nomRes = await fetch(url, {
                    headers: { 'User-Agent': 'Nematool' }
                });
                if (nomRes.ok) {
                    const { display_name } = await nomRes.json();
                    direccion = display_name || null;
                } else {
                    console.error(`Error estado ${nomRes.status}`);
                    direccion = window.location.href;
                }
            } catch (err) {
                console.error('Error al obtener ubicación:', err);
                direccion = window.location.href;
            }

            await axios.post('/waatic/añadir_registro', {
                fecha,
                email,
                seccion,
                evento,
                ip,
                direccion
            });
        } catch (e) {
            console.error('Error al registrar acceso:', e);
        }
    }, []);

    useEffect(() => {
        if (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error, life: 6000 });
        }
    }, [error]);

    useEffect(() => {
        registrarAcceso('load');
    }, [registrarAcceso]);

    useEffect(() => {
        const handler = () => registrarAcceso('click');
        document.addEventListener('pointerdown', handler);
        return () => {
            document.removeEventListener('pointerdown', handler);
        };
    }, [registrarAcceso]);

    return (
        <>
            <Analitics />
            <ModalInstall />
            <div className="flex flex-column align-items-center w-full" style={{ height: '100vh' }}>
                <div className="flex flex-column align-items-center w-full mobile-max-width">
                    <Toast ref={toast} position="top-center" className="w-11" />
                    <Header
                        isMain={isMain}
                        isNotifications={isNotifications}
                        isField={isField}
                        fieldId={fieldId}
                        isCreateField={isCreateField}
                        stepIndex={stepIndex}
                        prevStep={prevStep}
                    />
                    {children}  {/* Aquí se renderiza el contenido adicional */}
                </div>
            </div>
        </>
    );
};
